export interface WorldCupEdition {
  year: number;
  host: string;
  champion: string;
  championCode: string;
  runnerUp: string;
  topScorer: { name: string; goals: number; country: string };
}

export interface AllTimeTopScorer {
  name: string;
  country: string;
  goals: number;
  editions: string;
}

export const WORLD_CUP_EDITIONS: WorldCupEdition[] = [
  { year: 2022, host: 'Qatar', champion: 'Argentina', championCode: 'ARG', runnerUp: 'Francia', topScorer: { name: 'Kylian Mbappé', goals: 8, country: 'Francia' } },
  { year: 2018, host: 'Rusia', champion: 'Francia', championCode: 'FRA', runnerUp: 'Croacia', topScorer: { name: 'Harry Kane', goals: 6, country: 'Inglaterra' } },
  { year: 2014, host: 'Brasil', champion: 'Alemania', championCode: 'GER', runnerUp: 'Argentina', topScorer: { name: 'James Rodríguez', goals: 6, country: 'Colombia' } },
  { year: 2010, host: 'Sudáfrica', champion: 'España', championCode: 'ESP', runnerUp: 'Países Bajos', topScorer: { name: 'Diego Forlán', goals: 5, country: 'Uruguay' } },
  { year: 2006, host: 'Alemania', champion: 'Italia', championCode: 'ITA', runnerUp: 'Francia', topScorer: { name: 'Miroslav Klose', goals: 5, country: 'Alemania' } },
  { year: 2002, host: 'Corea / Japón', champion: 'Brasil', championCode: 'BRA', runnerUp: 'Alemania', topScorer: { name: 'Ronaldo', goals: 8, country: 'Brasil' } },
  { year: 1998, host: 'Francia', champion: 'Francia', championCode: 'FRA', runnerUp: 'Brasil', topScorer: { name: 'Davor Šuker', goals: 6, country: 'Croacia' } },
  { year: 1994, host: 'Estados Unidos', champion: 'Brasil', championCode: 'BRA', runnerUp: 'Italia', topScorer: { name: 'Hristo Stoichkov', goals: 6, country: 'Bulgaria' } },
  { year: 1990, host: 'Italia', champion: 'Alemania', championCode: 'GER', runnerUp: 'Argentina', topScorer: { name: 'Salvatore Schillaci', goals: 6, country: 'Italia' } },
  { year: 1986, host: 'México', champion: 'Argentina', championCode: 'ARG', runnerUp: 'Alemania', topScorer: { name: 'Gary Lineker', goals: 6, country: 'Inglaterra' } },
  { year: 1982, host: 'España', champion: 'Italia', championCode: 'ITA', runnerUp: 'Alemania', topScorer: { name: 'Paolo Rossi', goals: 6, country: 'Italia' } },
  { year: 1978, host: 'Argentina', champion: 'Argentina', championCode: 'ARG', runnerUp: 'Países Bajos', topScorer: { name: 'Mario Kempes', goals: 6, country: 'Argentina' } },
  { year: 1974, host: 'Alemania', champion: 'Alemania', championCode: 'GER', runnerUp: 'Países Bajos', topScorer: { name: 'Grzegorz Lato', goals: 7, country: 'Polonia' } },
  { year: 1970, host: 'México', champion: 'Brasil', championCode: 'BRA', runnerUp: 'Italia', topScorer: { name: 'Gerd Müller', goals: 10, country: 'Alemania' } },
  { year: 1966, host: 'Inglaterra', champion: 'Inglaterra', championCode: 'ENG', runnerUp: 'Alemania', topScorer: { name: 'Eusébio', goals: 9, country: 'Portugal' } },
  { year: 1962, host: 'Chile', champion: 'Brasil', championCode: 'BRA', runnerUp: 'Checoslovaquia', topScorer: { name: 'Flórián Albert', goals: 4, country: 'Hungría' } },
  { year: 1958, host: 'Suecia', champion: 'Brasil', championCode: 'BRA', runnerUp: 'Suecia', topScorer: { name: 'Just Fontaine', goals: 13, country: 'Francia' } },
  { year: 1954, host: 'Suiza', champion: 'Alemania', championCode: 'GER', runnerUp: 'Hungría', topScorer: { name: 'Sándor Kocsis', goals: 11, country: 'Hungría' } },
  { year: 1950, host: 'Brasil', champion: 'Uruguay', championCode: 'URU', runnerUp: 'Brasil', topScorer: { name: 'Ademir', goals: 9, country: 'Brasil' } },
  { year: 1938, host: 'Francia', champion: 'Italia', championCode: 'ITA', runnerUp: 'Hungría', topScorer: { name: 'Leônidas', goals: 7, country: 'Brasil' } },
  { year: 1934, host: 'Italia', champion: 'Italia', championCode: 'ITA', runnerUp: 'Checoslovaquia', topScorer: { name: 'Oldřich Nejedlý', goals: 5, country: 'Checoslovaquia' } },
  { year: 1930, host: 'Uruguay', champion: 'Uruguay', championCode: 'URU', runnerUp: 'Argentina', topScorer: { name: 'Guillermo Stábile', goals: 8, country: 'Argentina' } },
];

export const ALL_TIME_TOP_SCORERS: AllTimeTopScorer[] = [
  { name: 'Miroslav Klose', country: 'Alemania', goals: 16, editions: '2002–2014' },
  { name: 'Ronaldo', country: 'Brasil', goals: 15, editions: '1998–2006' },
  { name: 'Gerd Müller', country: 'Alemania', goals: 14, editions: '1970' },
  { name: 'Just Fontaine', country: 'Francia', goals: 13, editions: '1958' },
  { name: 'Pelé', country: 'Brasil', goals: 12, editions: '1958–1970' },
  { name: 'Kylian Mbappé', country: 'Francia', goals: 12, editions: '2018–2022' },
  { name: 'Sándor Kocsis', country: 'Hungría', goals: 11, editions: '1954' },
  { name: 'Jürgen Klinsmann', country: 'Alemania', goals: 11, editions: '1990–1998' },
];

export const CHAMPIONS_TITLES = [
  { country: 'Brasil', titles: 5 },
  { country: 'Alemania', titles: 4 },
  { country: 'Italia', titles: 4 },
  { country: 'Argentina', titles: 3 },
  { country: 'Francia', titles: 2 },
  { country: 'Uruguay', titles: 2 },
  { country: 'Inglaterra', titles: 1 },
  { country: 'España', titles: 1 },
];
